var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-responsive', [_c('v-card', {
    attrs: {
      "tile": "",
      "elevation": "0"
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.boards,
      "headers": _vm.headers,
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": "",
      "items-per-page": -1
    },
    scopedSlots: _vm._u([{
      key: "item.no",
      fn: function fn(_ref) {
        var item = _ref.item;
        return _c('span', {}, [item.isNotice ? _c('v-icon', {
          attrs: {
            "color": "yellow darken-2"
          }
        }, [_vm._v("mdi-alert-circle-outline")]) : _c('span', [_vm._v(_vm._s((_vm.page - 1) * _vm.limit + +_vm.boards.filter(function (noti) {
          return !noti.isNotice;
        }).indexOf(item) + 1))])], 1);
      }
    }, {
      key: "item.subject",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return _c('v-btn', {
          attrs: {
            "text": "",
            "tile": "",
            "to": "/board/event/".concat(item._id)
          }
        }, [_vm._v(_vm._s(item.subject))]);
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return _c('span', {}, [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")))]);
      }
    }])
  })], 1), _c('v-pagination', {
    staticClass: "mt-4",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }